import {
  ShoppingListFilterOption,
  ShoppingListSortOption,
} from 'src/types/view_shopping_lists/ShoppingList';

export const SHOPPING_LIST_FILTER_OPTIONS: ShoppingListFilterOption[] = [
  { value: 'all', label: 'Show All Lists' },
  { value: 'owned-by-me', label: 'Show Lists Owned by Me' },
  { value: 'shared-with-me', label: 'Show Lists Shared with Me' },
  { value: 'shared-by-me', label: 'Show Lists Shared by Me' },
  { value: 'copied-to-me', label: 'Show Lists Copied to Me' },
];

export const SHOPPING_LIST_SORT_OPTIONS: ShoppingListSortOption[] = [
  { value: 'name-asc', label: 'Name - Ascending' },
  { value: 'name-desc', label: 'Name - Descending' },
];
